/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_APPLICATION_TABLE } from "../pages/DoftApplication/graphql";
import { toast } from "react-hot-toast";

const MODULE_NAME = "OnboardOfficerService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class ApplicationTableService {
    private static instance: ApplicationTableService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): ApplicationTableService {
        if (!ApplicationTableService.instance) {
            ApplicationTableService.instance = new ApplicationTableService(
                props
            );
        }
        return ApplicationTableService.instance;
    }

    async getApplicationTable(limit: number, skip: number, filter: any, criteria:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        let crit ;
        console.log(
            "ApplicationTableService::getApplicationTable()-> reached here..", filter,criteria
        );
        if(criteria === "approved-app"){
            crit = true
        }
        else{
            crit = false
        }
        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_TABLE,
                    variables: {
                        criteria: {
                            
                            approvedApplication:crit ,
                            ...filter
                            // approvedApplication: true
                        },
                        skip: skip,
                        limit: limit
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getApplicationTable: ", res?.data);
                if (res?.data?.getApplicationTable) {
                    return res?.data?.getApplicationTable;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
